export const GoogleMapApiConfig = 'AIzaSyDH3yO7G5PDsJDoWDkdpiqVCzaA-hhHodI';